<template>
  <div class="w-7 h-7 flex justify-center items-center cursor-pointer select-none" 
       :class="{ 'opacity-50 cursor-not-allowed': disabled }"
       @click="toggle">
    <!-- Checked state -->
    <div v-if="modelValue" class="w-4 h-4 bg-btn-primary rounded-sm flex justify-center items-center">
      <i class="ri-check-line text-text-inverse text-xs"></i>
    </div>
    <!-- Unchecked state -->
    <div v-else class="w-4 h-4 border border-border-default rounded-sm hover:border-brand-outline transition-colors bg-surface-1"></div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  methods: {
    toggle() {
      if (this.disabled) return;
      this.$emit('update:modelValue', !this.modelValue);
    }
  }
}
</script>
